import React from 'react';
import { TopBar } from '../../components/layout/TopBar';
import { Header } from '../../components/layout/Header';
import { Navigation } from '../../components/layout/Navigation';
import { MobileStickyBar } from '../../components/layout/MobileStickyBar';
import { Footer } from '../../components/layout/Footer';
import { useScreenInit } from '../../useScreenInit';
import { CheckCircle2, MapPin, ShieldCheck, Users, Wrench, Award, HelpCircle, ArrowRight } from 'lucide-react';
export function AboutUs() {
  useScreenInit();
  return <div className="min-h-screen flex flex-col bg-brand-background" data-id="element-803">
      <TopBar data-id="element-804" />
      <Header data-id="element-805" />
      <Navigation data-id="element-806" />

      <main className="flex-grow" data-id="element-807">
        {/* Hero Section */}
        <section className="bg-white border-b border-brand-border py-16 lg:py-24" data-id="element-808">
          <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-809">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-goldSoft text-brand-charcoal text-xs font-bold tracking-wide mb-4 uppercase border border-brand-gold/30" data-id="element-810">
              First Impressions Start at the Curb
            </span>
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-brand-charcoal mb-6 leading-tight" data-id="element-811">
              Your Mailbox Experts Since 2003
            </h1>
            <p className="text-lg lg:text-xl text-brand-muted max-w-3xl mx-auto leading-relaxed" data-id="element-812">
              Welcome to MidAtlantic Mailbox, Inc. — your superstore for
              residential & commercial mailboxes, outdoor home accessories,
              street signs, and more. If you have a mailbox question, we're your
              answer.
            </p>
          </div>
        </section>

        {/* Trust & Values */}
        <section className="py-12 bg-brand-background border-b border-brand-border" data-id="element-813">
          <div className="max-w-7xl mx-auto px-4" data-id="element-814">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-815">
              <div className="bg-white p-6 rounded-xl border border-brand-border flex flex-col items-center text-center shadow-sm" data-id="element-816">
                <div className="w-12 h-12 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center mb-4" data-id="element-817">
                  <ShieldCheck size={24} data-id="element-818" />
                </div>
                <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-819">
                  22 Years of Service
                </h3>
                <p className="text-sm text-brand-muted" data-id="element-820">
                  Trusted service and expert industry knowledge since our
                  founding.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl border border-brand-border flex flex-col items-center text-center shadow-sm" data-id="element-821">
                <div className="w-12 h-12 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center mb-4" data-id="element-822">
                  <Users size={24} data-id="element-823" />
                </div>
                <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-824">
                  Family Owned & Operated
                </h3>
                <p className="text-sm text-brand-muted" data-id="element-825">
                  A small generational business dedicated to our community.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl border border-brand-border flex flex-col items-center text-center shadow-sm" data-id="element-826">
                <div className="w-12 h-12 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center mb-4" data-id="element-827">
                  <Award size={24} data-id="element-828" />
                </div>
                <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-829">
                  Top-Rated Manufacturers
                </h3>
                <p className="text-sm text-brand-muted" data-id="element-830">
                  We partner with the best to bring you quality street-scape
                  solutions.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl border border-brand-border flex flex-col items-center text-center shadow-sm" data-id="element-831">
                <div className="w-12 h-12 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center mb-4" data-id="element-832">
                  <Wrench size={24} data-id="element-833" />
                </div>
                <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-834">
                  Professional Setup
                </h3>
                <p className="text-sm text-brand-muted" data-id="element-835">
                  Expert project management and installation services.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Our Story */}
        <section className="py-16 lg:py-24 bg-white border-b border-brand-border" data-id="element-836">
          <div className="max-w-7xl mx-auto px-4" data-id="element-837">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-838">
              <div data-id="element-839">
                <span className="text-brand-maroon font-bold tracking-wider uppercase text-xs mb-4 block flex items-center gap-2" data-id="element-840">
                  <span className="w-6 h-px bg-brand-maroon" data-id="element-841"></span>
                  Our Story
                </span>
                <h2 className="text-3xl lg:text-4xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-842">
                  From a Garage Startup to a National Retailer
                </h2>
                <div className="space-y-4 text-brand-muted leading-relaxed" data-id="element-843">
                  <p data-id="element-844">
                    As a small generational business, we're excited to offer
                    quality mailboxes and street-scape solutions. Our matriarch,
                    Anne Ingram, launched this woman-owned & operated company in
                    2003.
                  </p>
                  <p data-id="element-845">
                    Over the next 22 years, she earned the reputation in the
                    Mid-Atlantic Region as the "Mailbox Lady," and now, she's
                    looking to pass the torch to her daughters.
                  </p>
                  <p data-id="element-846">
                    In typical start-up fashion, her now-booming business all
                    began in her garage with a determination to make her mark on
                    the mailbox industry and help the community navigate a
                    confusing sector. Since that garage start-up, MidAtlantic
                    Mailbox has grown to be a top national retailer for
                    commercial and residential street-scape needs.
                  </p>
                </div>
                <div className="mt-8 flex gap-4" data-id="element-847">
                  <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/woman%20owned%20badge.png" alt="Woman Owned Business" className="h-16 object-contain" data-id="element-848" />
                  <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/family%20owned%20badge.png" alt="Family Owned Business" className="h-16 object-contain" data-id="element-849" />
                </div>
              </div>
              <div className="relative" data-id="element-850">
                <div className="aspect-square lg:aspect-auto lg:h-[500px] rounded-2xl overflow-hidden shadow-lg border border-brand-border" data-id="element-851">
                  <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/working%20hands.png" alt="MidAtlantic Mailbox Team" className="w-full h-full object-cover" data-id="element-852" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Expertise & Services */}
        <section className="py-16 lg:py-24 bg-brand-goldWash border-b border-brand-border" data-id="element-853">
          <div className="max-w-7xl mx-auto px-4" data-id="element-854">
            <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-855">
              <h2 className="text-3xl lg:text-4xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-856">
                Your Mailbox Experts Are Here to Help
              </h2>
              <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-857">
                MidAtlantic's women-led team is reaching for new heights,
                excited to serve communities, property managers, homeowners, and
                postal workers. We look forward to working directly with you and
                your land or planning departments to assist in designing your
                next project.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-858">
              <div className="bg-white p-8 rounded-xl border border-brand-border shadow-sm" data-id="element-859">
                <h3 className="font-bold text-brand-charcoal text-xl mb-4" data-id="element-860">
                  Commercial Planning
                </h3>
                <ul className="space-y-3 text-brand-muted" data-id="element-861">
                  <li className="flex items-start gap-2" data-id="element-862">
                    <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-863" />
                    <span data-id="element-864">Replacement CBU's & New Developments</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-865">
                    <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-866" />
                    <span data-id="element-867">Advisal of Commercial Postal Codes & Ordinances</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-868">
                    <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-869" />
                    <span data-id="element-870">Value Engineered Development Mailbox Mapping</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-xl border border-brand-border shadow-sm" data-id="element-871">
                <h3 className="font-bold text-brand-charcoal text-xl mb-4" data-id="element-872">
                  Professional Installation
                </h3>
                <p className="text-brand-muted mb-4" data-id="element-873">
                  We’re here to shoulder the hard parts of mailbox replacements.
                  Once installation is scheduled, there’s nothing left for you
                  to do.
                </p>
                <ul className="space-y-3 text-brand-muted" data-id="element-874">
                  <li className="flex items-start gap-2" data-id="element-875">
                    <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-876" />
                    <span data-id="element-877">Removal, installation, and disposal</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-878">
                    <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-879" />
                    <span data-id="element-880">Proper positioning for easy mail delivery</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-xl border border-brand-border shadow-sm" data-id="element-881">
                <h3 className="font-bold text-brand-charcoal text-xl mb-4" data-id="element-882">
                  Diagnostic Solutions
                </h3>
                <p className="text-brand-muted mb-4" data-id="element-883">
                  We stay informed of postal requirements along with emerging
                  industry trends to bring you the most up to date products and
                  services.
                </p>
                <ul className="space-y-3 text-brand-muted" data-id="element-884">
                  <li className="flex items-start gap-2" data-id="element-885">
                    <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-886" />
                    <span data-id="element-887">Model identification</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-888">
                    <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-889" />
                    <span data-id="element-890">Affordable street themes</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* FAQs */}
        <section className="py-16 lg:py-24 bg-white border-b border-brand-border" data-id="element-891">
          <div className="max-w-4xl mx-auto px-4" data-id="element-892">
            <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-10 text-center" data-id="element-893">
              Common Installation Questions
            </h2>
            <div className="space-y-6" data-id="element-894">
              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-895">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-896">
                  <HelpCircle size={20} className="text-brand-maroon" data-id="element-897" />
                  Why should MidAtlantic Mailbox install my mailbox?
                </h3>
                <p className="text-brand-muted leading-relaxed" data-id="element-898">
                  <strong data-id="element-899">Ease of Mind:</strong> We’ll take care of removal,
                  installation, and disposing of the old system. You don’t even
                  have to be home!
                  <br data-id="element-900" />
                  <strong data-id="element-901">Professional Setup:</strong> Our experienced team
                  ensures your mailbox is installed to meet all local
                  regulations.
                  <br data-id="element-902" />
                  <strong data-id="element-903">Durability and Security:</strong> Our manufacturers
                  use high-quality materials to ensure your mailbox lasts for
                  years.
                </p>
              </div>

              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-904">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-905">
                  <HelpCircle size={20} className="text-brand-maroon" data-id="element-906" />I didn't
                  buy my mailbox from MidAtlantic Mailbox. Will you still
                  install it?
                </h3>
                <p className="text-brand-muted leading-relaxed" data-id="element-907">
                  It depends! If you are in our service area and there is
                  availability on our schedule, we can complete a direct burial
                  installation. However, we can only guarantee the craftsmanship
                  of the physical installation; any issues with the products
                  should be brought to the company you purchased from.
                </p>
              </div>

              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-908">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-909">
                  <HelpCircle size={20} className="text-brand-maroon" data-id="element-910" />
                  Do I need Post Office approval to replace my mailbox?
                </h3>
                <p className="text-brand-muted leading-relaxed mb-4" data-id="element-911">
                  Unless you’re moving your mailbox location, you generally
                  don’t need USPS approval to complete a residential
                  installation. We’ll ensure your mailbox is compliant with USPS
                  regulations during installation. All of MidAtlantic Mailbox’s
                  products are also USPS Approved.
                </p>
                <a href="/USPSResources.html" className="inline-flex items-center text-brand-maroon font-semibold hover:text-brand-maroonDark transition-colors" data-id="element-912">
                  View USPS resources <ArrowRight size={16} className="ml-1" data-id="element-913" />
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Awards */}
        <section className="py-16 bg-brand-background border-b border-brand-border" data-id="element-914">
          <div className="max-w-7xl mx-auto px-4" data-id="element-915">
            <h2 className="text-2xl font-serif font-bold text-brand-charcoal mb-8 text-center" data-id="element-916">
              Awards & Recognition
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-917">
              <a href="https://www.florencemailboxes.com/dealers/midatlantic-mailbox-inc/" target="_blank" rel="noopener noreferrer" className="bg-white p-6 rounded-xl border border-brand-border text-center shadow-sm flex flex-col items-center justify-center hover:border-brand-maroon transition-colors group" data-id="element-918">
                <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/florence%20logo%20badge.png" alt="Florence Manufacturing" className="h-12 object-contain mb-4" data-id="element-919" />
                <h4 className="font-bold text-brand-charcoal text-sm mb-1 group-hover:text-brand-maroon transition-colors" data-id="element-920">
                  Dealer of Excellence Award
                </h4>
                <p className="text-xs text-brand-muted" data-id="element-921">
                  2011 to 2024 · Florence Manufacturing
                </p>
              </a>
              <div className="bg-white p-6 rounded-xl border border-brand-border text-center shadow-sm flex flex-col items-center justify-center" data-id="element-922">
                <Award size={32} className="text-brand-gold mb-4" data-id="element-923" />
                <h4 className="font-bold text-brand-charcoal text-sm mb-1" data-id="element-924">
                  Best of Frederick Economic Development
                </h4>
                <p className="text-xs text-brand-muted" data-id="element-925">
                  2017 - Rooted in Frederick 15 years
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl border border-brand-border text-center shadow-sm flex flex-col items-center justify-center" data-id="element-926">
                <Award size={32} className="text-brand-gold mb-4" data-id="element-927" />
                <h4 className="font-bold text-brand-charcoal text-sm mb-1" data-id="element-928">
                  Best of Frederick Economic Development
                </h4>
                <p className="text-xs text-brand-muted" data-id="element-929">
                  2012 - Small Business
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl border border-brand-border text-center shadow-sm flex flex-col items-center justify-center" data-id="element-930">
                <Award size={32} className="text-brand-gold mb-4" data-id="element-931" />
                <h4 className="font-bold text-brand-charcoal text-sm mb-1" data-id="element-932">
                  Top 25 Seller with A+ Service
                </h4>
                <p className="text-xs text-brand-muted" data-id="element-933">2012 Amazon</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 lg:py-24 bg-white text-center" data-id="element-934">
          <div className="max-w-3xl mx-auto px-4" data-id="element-935">
            <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-936">
              Ready to start your project?
            </h2>
            <p className="text-lg text-brand-muted mb-8" data-id="element-937">
              Contact our office for a custom quote, design assistance, or any
              general questions you may have.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-938">
              <a href="/ContactUs.html" className="bg-brand-maroon hover:bg-brand-maroonDark text-white px-8 py-3.5 rounded-md font-bold transition-colors shadow-sm w-full sm:w-auto" data-id="element-939">
                Contact Us
              </a>
              <a href="tel:301-620-7585" className="bg-white border border-brand-border hover:border-brand-maroon text-brand-charcoal px-8 py-3.5 rounded-md font-bold transition-colors shadow-sm w-full sm:w-auto flex items-center justify-center gap-2" data-id="element-940">
                Call 301-620-7585
              </a>
            </div>
            <div className="mt-10 pt-8 border-t border-brand-border text-sm text-brand-muted max-w-xl mx-auto" data-id="element-941">
              <p className="font-semibold text-brand-charcoal mb-1" data-id="element-942">
                MidAtlantic Mailbox, Inc.
              </p>
              <p className="flex items-center justify-center gap-2 mb-3" data-id="element-943">
                <MapPin size={16} className="text-brand-gold shrink-0" data-id="element-944" />
                4507 Metropolitan Court Ste. D, Frederick, MD 21704
              </p>
              <p className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1" data-id="element-945">
                <span data-id="element-946">Toll Free: 1-800-806-7997</span>
                <span className="hidden sm:inline text-brand-border" data-id="element-947">|</span>
                <span data-id="element-948">Local: 301-620-7585</span>
                <span className="hidden sm:inline text-brand-border" data-id="element-949">|</span>
                <span data-id="element-950">301-620-7867</span>
                <span className="hidden sm:inline text-brand-border" data-id="element-951">|</span>
                <span data-id="element-952">240-575-5852</span>
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-953" />
      <MobileStickyBar data-id="element-954" />
    </div>;
}